import type { InferenceResponse } from "./getDefectsSuggestions.type";
import type { EmptyObject, LiteralObject } from "@/types";

import { client } from "@/config/client";

const INFERENCE_MAX_RETRIES = 5;

export const getMaterialEndpoint = (material = "") => {
  if (!material) {
    return undefined;
  }
  return `prod-${material}-defect`;
};

export const callInferenceEndpoint = async ({ body = {}, endpoint = "" }) => {
  const data = {
    endpoint_name: endpoint,
    body: body,
  };

  let inferenceResponse = null;
  let attempts = 0;
  do {
    try {
      // TODO IMP-1218 fix no-await-in-loop
      // eslint-disable-next-line no-await-in-loop
      inferenceResponse = (await client.inference.create(
        data
      )) as InferenceResponse;
      break;
    } catch (error) {
      if ((error as LiteralObject)?.response) {
        break;
      }
      // If no response, it's probably due to timeout, try again
    }
    attempts++;
  } while (attempts < INFERENCE_MAX_RETRIES);
  // Retry on gateway timeout due to AWS Sagemaker cold start
  const inferenceResults: InferenceResponse | EmptyObject =
    inferenceResponse !== null ? inferenceResponse.data : {};

  return inferenceResults;
};
